import { useEffect } from "react";

/**
 * Adds <meta name="robots" content="noindex,nofollow"> to the document head
 * while the calling component is mounted. Use on private pages (admin,
 * account, checkout) so Google drops them from the index instead of just
 * blocking them via robots.txt (which causes "Indexed, though blocked"
 * warnings in Search Console).
 */
export default function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
}
